import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EditTransactionFormComponent } from '../../shared/edit-transaction-form/edit-transaction-form.component';

@Injectable({
    providedIn: 'root',
})
export class ModalService {
    constructor(private dialog: MatDialog) {
    }

    openEditTransactionModal(transactionId: string): void {
        const dialogRef = this.dialog.open(EditTransactionFormComponent, {
            data: {transactionId: transactionId},
            width: '360px',
        });
    }
}
